export class CompanyLookup {
  name: string;
  street: string;
  zip: string;
  city: string;
  country: string;

  static copy(oldObj: CompanyLookup): CompanyLookup {
    const newObj = new CompanyLookup();
    newObj.name = oldObj.name;
    newObj.street = oldObj.street;
    newObj.zip = oldObj.zip;
    newObj.city = oldObj.city;
    newObj.country = oldObj.country;
    return newObj;
  }

  clone(): CompanyLookup {
    return CompanyLookup.copy(this);
  }
}
